import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Check, RefreshCw } from "lucide-react"; // Removed ArrowRight
import { format } from "date-fns";
// Removed: import { createPageUrl } from "@/utils";
// Removed: import { Link } from "react-router-dom";

export default function SuccessPage({ disputeId, disputeData, selectedCardholder, selectedTransactions, onNewDispute }) {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(amount);
  };

  const totalDisputeAmount = selectedTransactions.reduce((sum, t) => sum + t.amount, 0);

  return (
    <Card className="border-l-4 border-l-green-500 shadow-md">
      <CardHeader className="flex flex-row items-center justify-between pb-2">
        <CardTitle className="text-lg font-semibold flex items-center">
          <Check className="mr-2 h-5 w-5 text-green-500" />
          Dispute Submitted Successfully
        </CardTitle>
      </CardHeader>
      
      <CardContent className="space-y-6">
        <div className="bg-green-50 border border-green-100 rounded-lg p-6 text-center">
          <div className="mx-auto w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <Check className="h-6 w-6 text-green-600" />
          </div>
          
          <h3 className="text-xl font-semibold text-gray-800 mb-2">Dispute #{disputeId}</h3>
          <p className="text-gray-600">
            A dispute has been created on behalf of {selectedCardholder.full_name} and submitted for processing.
          </p>
          
          <div className="mt-6 border-t border-green-100 pt-4">
            <div className="grid grid-cols-2 gap-y-3 text-left">
              <div className="text-sm text-gray-500">Type:</div>
              <div className="text-sm font-medium">{disputeData.disputeType}</div>
              
              <div className="text-sm text-gray-500">Submitted On:</div>
              <div className="text-sm font-medium">{format(new Date(), "MMM d, yyyy h:mm a")}</div>
              
              <div className="text-sm text-gray-500">Transactions:</div>
              <div className="text-sm font-medium">{selectedTransactions.length} transaction(s)</div>
              
              <div className="text-sm text-gray-500">Total Amount:</div>
              <div className="text-sm font-medium">{formatCurrency(totalDisputeAmount)}</div>
              
              <div className="text-sm text-gray-500">Status:</div>
              <div className="text-sm font-medium">
                <span className="bg-blue-100 text-blue-800 text-xs py-1 px-2 rounded-full">
                  Processing
                </span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="bg-gray-50 p-4 rounded-md border text-center">
          <p className="text-sm text-gray-600">
            A confirmation email with dispute details has been sent to the cardholder.
            <br />You can now proceed to submit another dispute.
          </p>
        </div>
      </CardContent>
      
      <CardFooter className="flex flex-col sm:flex-row gap-3 justify-center pt-2 pb-6">
        <Button 
          variant="outline"
          onClick={onNewDispute}
          className="flex items-center gap-2 w-full sm:w-auto"
        >
          <RefreshCw className="h-4 w-4" />
          Submit Another Dispute
        </Button>
      </CardFooter>
    </Card>
  );
}